export default __webpack_public_path__ + "static/media/s2p1.5a8e215a.jpg";